import { SVGProps, Ref, forwardRef } from 'react';

export const BankFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.9 18.01c.414-.01.884-.01 1.424-.01h2.109V9.75h1.8V18h3.534V9.75h1.8V18h2.109c.54 0 1.01 0 1.424.01V9.75h1.8v8.477c.258.08.484.19.692.34.785.566 1.115 1.556 1.775 3.536L24 24H0l.633-1.897c.66-1.98.99-2.97 1.775-3.536.208-.15.434-.26.692-.34V9.75h1.8z"
                fill="currentColor"
            />
            <path
                d="M12 .033c.2-.08.39 0 .77.237L24 4.95v1c0 .863 0 1.334-.293 1.707-.293.213-.764.213-1.707.293H2C1.057 7.87.586 7.87.293 7.657 0 7.284 0 6.813 0 5.95v-1L11.23.27c.38-.238.57-.317.77-.237"
                fill="currentColor"
            />
        </g>
    </svg>
));
BankFilledSize24Glyph.displayName = 'BankFilledSize24Glyph';
